import React, { FC } from 'react';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { IActionPages } from 'core/interface/actionPages';

import './Index.scss';

const Congrats: FC<IActionPages> = ({ t, onSubmit }): JSX.Element => {
  const handleSubmit = (): void => {
    onSubmit();
  };

  return (
    <div className="congratsBLock">
      <Image name="congrats.svg" width={440} height={483} />
      <h1 className="congrats-title">{t('Congratulations!')}</h1>
      <p className="congrats-desc">{t('You are about to embark on an exciting journey with our competency assessment. This is your chance to shine and demonstrate the unique skills and talents you possess.')}</p>
      <Button
        onClick={handleSubmit}
        className="congrats-continue"
        title="Continue"
        t={t}
      />
    </div>
  );
};

export default Congrats;
